import type { JourneyStep } from "../../types/journey";
import styles from "./StepDetail.module.css";

interface StepDetailProps {
	step: JourneyStep | null;
}

export function StepDetail({ step }: StepDetailProps) {
	if (!step) return null;

	return (
		<section className={styles.container} data-step-content="step-detail">
			{/* The "Estimated : {range}" line is hidden for now. estimatedDateRange is
			    freeform, pre-localized text that usually carries a specific calendar
			    date (e.g. "Est. May 2, 2026 [CD13, …]"); those dates are unreliable and
			    must not be shown. Stripping only the dates can't be done safely across
			    all 5 locales without risking leaks, so the whole line is hidden. To
			    restore: re-add the useClientTranslations import and
			    <p className={styles.estimated}>{t("stepDetail.estimated", { range:
			    step.estimatedDateRange })}</p>. */}
			<p className={styles.description}>{step.description}</p>
		</section>
	);
}
